import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 電話アイコン
 */
const TelIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="148"
        height="111.108"
        viewBox="0 0 148 111.108"
      >
        <defs>
          <filter
            id="mapIconA"
            x="13.816"
            y="0"
            width="49.85"
            height="49.85"
            filterUnits="userSpaceOnUse"
          >
            <feGaussianBlur stdDeviation="3" result="mapIconB" />
            <feFlood floodOpacity="0.239" />
            <feComposite operator="in" in2="mapIconB" />
            <feComposite in="SourceGraphic" />
          </filter>
          <filter
            id="mapIconC"
            x="83"
            y="53.166"
            width="49.85"
            height="49.85"
            filterUnits="userSpaceOnUse"
          >
            <feGaussianBlur stdDeviation="3" result="d" />
            <feFlood floodOpacity="0.239" />
            <feComposite operator="in" in2="d" />
            <feComposite in="SourceGraphic" />
          </filter>
        </defs>
        <g transform="translate(-111.919 -125.363)">
          <g transform="translate(111.919 155.228)">
            <g transform="translate(0 0)">
              <rect
                width="6.554"
                height="8.124"
                rx="3.277"
                transform="translate(0 8.801)"
                fill="var(--color-disabled)"
              />
              <rect
                width="103.764"
                height="8.124"
                rx="4.062"
                transform="translate(8.738 8.801)"
                fill="var(--color-disabled)"
              />
              <rect
                width="109.225"
                height="8.124"
                rx="4.062"
                transform="translate(19.661 42.653)"
                fill="var(--color-disabled)"
              />
              <rect
                width="109.225"
                height="8.124"
                rx="4.062"
                transform="translate(38.775 61.61)"
                fill="var(--color-disabled)"
              />
              <rect
                width="3.277"
                height="81.244"
                rx="1.638"
                transform="translate(105.948)"
                fill="var(--color-disabled)"
              />
              <rect
                width="3.277"
                height="54.162"
                rx="1.638"
                transform="translate(52.428)"
                fill="var(--color-disabled)"
              />
              <rect
                width="6.554"
                height="81.244"
                rx="3.277"
                transform="translate(77.55)"
                fill="var(--color-disabled)"
              />
            </g>
            <g transform="translate(38.229 12.084)">
              <rect width="43.744" height="1.635" fill="var(--color-text)" />
              <rect
                width="27.393"
                height="2.086"
                transform="translate(41.965 52.856)"
                fill="var(--color-text)"
              />
              <rect
                width="1.778"
                height="54.162"
                transform="translate(41.965 0.78)"
                fill="var(--color-text)"
              />
            </g>
          </g>
          <g transform="translate(130.798 130.5)">
            <g transform="translate(5.936 5.863)">
              <g
                transform="matrix(1, 0, 0, 1, -24.82, -11)"
                filter="url(#mapIconA)"
              >
                <g transform="translate(24.82 11)" fill="var(--color-error)">
                  <path
                    d="M 22.24483871459961 28.84983825683594 L 5.604998111724854 28.84983825683594 C 1.962988138198853 28.84983825683594 -1.000001788139343 25.88684844970703 -1.000001788139343 22.24483871459961 L -1.000001788139343 5.604998111724854 C -1.000001788139343 1.962988138198853 1.962988138198853 -1.000001788139343 5.604998111724854 -1.000001788139343 L 22.24483871459961 -1.000001788139343 C 25.88684844970703 -1.000001788139343 28.84983825683594 1.962988138198853 28.84983825683594 5.604998111724854 L 28.84983825683594 22.24483871459961 C 28.84983825683594 25.88684844970703 25.88684844970703 28.84983825683594 22.24483871459961 28.84983825683594 Z"
                    stroke="none"
                  />
                  <path
                    d="M 5.604997634887695 -1.9073486328125e-06 C 2.509437561035156 -1.9073486328125e-06 -1.9073486328125e-06 2.509437561035156 -1.9073486328125e-06 5.604997634887695 L -1.9073486328125e-06 22.24483871459961 C -1.9073486328125e-06 25.34039878845215 2.509437561035156 27.84983825683594 5.604997634887695 27.84983825683594 L 22.24483871459961 27.84983825683594 C 25.34039878845215 27.84983825683594 27.84983825683594 25.34039878845215 27.84983825683594 22.24483871459961 L 27.84983825683594 5.604997634887695 C 27.84983825683594 2.509437561035156 25.34039878845215 -1.9073486328125e-06 22.24483871459961 -1.9073486328125e-06 L 5.604997634887695 -1.9073486328125e-06 M 5.604997634887695 -2.000001907348633 L 22.24483871459961 -2.000001907348633 C 26.43824768066406 -2.000001907348633 29.84983825683594 1.411588668823242 29.84983825683594 5.604997634887695 L 29.84983825683594 22.24483871459961 C 29.84983825683594 26.43824768066406 26.43824768066406 29.84983825683594 22.24483871459961 29.84983825683594 L 5.604997634887695 29.84983825683594 C 1.411588668823242 29.84983825683594 -2.000001907348633 26.43824768066406 -2.000001907348633 22.24483871459961 L -2.000001907348633 5.604997634887695 C -2.000001907348633 1.411588668823242 1.411588668823242 -2.000001907348633 5.604997634887695 -2.000001907348633 Z"
                    stroke="none"
                    fill="var(--color-content-background)"
                  />
                </g>
              </g>
              <path
                d="M15.558,7.065h-2.3V4H2.532A1.537,1.537,0,0,0,1,5.532v8.428H2.532a2.3,2.3,0,0,0,4.6,0h4.6a2.3,2.3,0,0,0,4.6,0h1.532V10.13ZM4.831,15.11A1.149,1.149,0,1,1,5.98,13.961,1.148,1.148,0,0,1,4.831,15.11Zm10.344-6.9,1.5,1.916H13.259V8.214Zm-1.149,6.9a1.149,1.149,0,1,1,1.149-1.149A1.148,1.148,0,0,1,14.025,15.11Z"
                transform="translate(4.497 3.695)"
                fill="var(--color-content-background)"
              />
            </g>
            <rect width="39.576" height="39.576" fill="none" />
            <path
              d="M3.3,0,6.6,5.863H0Z"
              transform="translate(23.416 38.586) rotate(180)"
              fill="var(--color-error)"
            />
          </g>
          <g transform="translate(201.045 182.311)">
            <rect width="39.576" height="39.576" fill="none" />
            <g transform="translate(4.141 4.653)">
              <rect
                width="29.316"
                height="32.98"
                transform="translate(0 0)"
                fill="none"
              />
              <g
                transform="matrix(1, 0, 0, 1, -93.27, -61.6)"
                filter="url(#mapIconC)"
              >
                <g transform="translate(94 64.17)" fill="var(--color-text)">
                  <path
                    d="M 22.24483871459961 28.84983825683594 L 5.604998111724854 28.84983825683594 C 1.962988138198853 28.84983825683594 -1.000001788139343 25.88684844970703 -1.000001788139343 22.24483871459961 L -1.000001788139343 5.604998111724854 C -1.000001788139343 1.962988138198853 1.962988138198853 -1.000001788139343 5.604998111724854 -1.000001788139343 L 22.24483871459961 -1.000001788139343 C 25.88684844970703 -1.000001788139343 28.84983825683594 1.962988138198853 28.84983825683594 5.604998111724854 L 28.84983825683594 22.24483871459961 C 28.84983825683594 25.88684844970703 25.88684844970703 28.84983825683594 22.24483871459961 28.84983825683594 Z"
                    stroke="none"
                  />
                  <path
                    d="M 5.604997634887695 -1.9073486328125e-06 C 2.509437561035156 -1.9073486328125e-06 -1.9073486328125e-06 2.509437561035156 -1.9073486328125e-06 5.604997634887695 L -1.9073486328125e-06 22.24483871459961 C -1.9073486328125e-06 25.34039878845215 2.509437561035156 27.84983825683594 5.604997634887695 27.84983825683594 L 22.24483871459961 27.84983825683594 C 25.34039878845215 27.84983825683594 27.84983825683594 25.34039878845215 27.84983825683594 22.24483871459961 L 27.84983825683594 5.604997634887695 C 27.84983825683594 2.509437561035156 25.34039878845215 -1.9073486328125e-06 22.24483871459961 -1.9073486328125e-06 L 5.604997634887695 -1.9073486328125e-06 M 5.604997634887695 -2.000001907348633 L 22.24483871459961 -2.000001907348633 C 26.43824768066406 -2.000001907348633 29.84983825683594 1.411588668823242 29.84983825683594 5.604997634887695 L 29.84983825683594 22.24483871459961 C 29.84983825683594 26.43824768066406 26.43824768066406 29.84983825683594 22.24483871459961 29.84983825683594 L 5.604997634887695 29.84983825683594 C 1.411588668823242 29.84983825683594 -2.000001907348633 26.43824768066406 -2.000001907348633 22.24483871459961 L -2.000001907348633 5.604997634887695 C -2.000001907348633 1.411588668823242 1.411588668823242 -2.000001907348633 5.604997634887695 -2.000001907348633 Z"
                    stroke="none"
                    fill="var(--color-content-background)"
                  />
                </g>
              </g>
              <path
                d="M3.3,0,6.6,5.863H0Z"
                transform="translate(17.956 35.912) rotate(180)"
                fill="var(--color-text)"
              />
              <path
                d="M15.478,5.792A1.171,1.171,0,0,0,14.365,5H5.743a1.179,1.179,0,0,0-1.113.792L3,10.487v6.271a.786.786,0,0,0,.784.784h.784a.786.786,0,0,0,.784-.784v-.784h9.406v.784a.786.786,0,0,0,.784.784h.784a.786.786,0,0,0,.784-.784V10.487Zm-9.735,7.83a1.176,1.176,0,1,1,1.176-1.176A1.174,1.174,0,0,1,5.743,13.622Zm8.622,0a1.176,1.176,0,1,1,1.176-1.176A1.174,1.174,0,0,1,14.365,13.622ZM4.568,9.7,5.743,6.176h8.622L15.541,9.7Z"
                transform="translate(4.695 5.26)"
                fill="var(--color-content-background)"
              />
            </g>
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default TelIcon
